var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState, useMemo } from 'react';
import { debounce } from 'lodash';
import { useQuery } from '@tanstack/react-query';
import { ChainId, WRAPPED_SOL } from '@shared/utils/config/networks';
import { WrappedNativeTokens } from '@shared/types/quoting-engine/wrappedNativeTokens';
import { getBasicTokenInfo } from '../pricing/useBasicTokenInfo';
import { findBestMatch } from '@/lib/explore/findBestMatch';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
export var nativeTokens = [
    {
        tokenName: 'Ethereum',
        token: 'ETH',
        tokenId: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2:1',
        tokenAddress: '0x0000000000000000000000000000000000000000',
        network: 1,
        wrappedAddress: WrappedNativeTokens.get(1),
    },
    {
        tokenName: 'Avalanche',
        token: 'AVAX',
        tokenId: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7:43114',
        tokenAddress: '0x0000000000000000000000000000000000000000',
        network: 43114,
        wrappedAddress: WrappedNativeTokens.get(43114),
    },
    {
        tokenName: 'Binance',
        token: 'BNB',
        tokenId: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c:56',
        tokenAddress: '0x0000000000000000000000000000000000000000',
        network: 56,
        wrappedAddress: WrappedNativeTokens.get(56),
    },
    {
        tokenName: 'Polygon',
        token: 'POL',
        tokenId: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270:137',
        tokenAddress: '0x0000000000000000000000000000000000000000',
        network: 137,
        wrappedAddress: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    },
    {
        tokenName: 'Solana',
        token: 'SOL',
        tokenAddress: WRAPPED_SOL,
        network: 1399811149,
        wrappedAddress: WRAPPED_SOL,
    },
    {
        tokenName: 'Ethereum',
        token: 'ETH',
        tokenAddress: '0x0000000000000000000000000000000000000000',
        network: 8453,
        wrappedAddress: '0x4200000000000000000000000000000000000006',
    },
    {
        tokenName: 'Ethereum',
        token: 'ETH',
        tokenAddress: '0x0000000000000000000000000000000000000000',
        network: 42161,
        wrappedAddress: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    },
    {
        tokenName: 'Ethereum',
        token: 'ETH',
        tokenAddress: '0x0000000000000000000000000000000000000000',
        network: 10,
        wrappedAddress: '0x4200000000000000000000000000000000000006',
    },
];
export var fetchBatchTokens = function (tokens) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenIds, url, result, response, payload, data, error_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                tokenIds = tokens.join(',');
                url = "/api/explore/tokenBatchSearch?tokens=".concat(tokenIds, "&limit=").concat(tokens.length);
                result = [];
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(url)];
            case 2:
                response = _c.sent();
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return [4 /*yield*/, response.json()];
            case 3:
                payload = _c.sent();
                data = payload === null || payload === void 0 ? void 0 : payload.data;
                result = (_b = (_a = data.data) === null || _a === void 0 ? void 0 : _a.filterTokens) === null || _b === void 0 ? void 0 : _b.results;
                return [3 /*break*/, 5];
            case 4:
                error_1 = _c.sent();
                console.error('searchResults error', error_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, result || []];
        }
    });
}); };
export function fetchTokens(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var networks, url, result, nativeTokenIds, index, response, payload, data, ethTokens, bnbTokens, otherTokens, error_2;
        var _this = this;
        var _c, _d, _e, _f;
        var limit = _b.limit, phrase = _b.phrase, network = _b.network, _g = _b.txnCountMin, txnCountMin = _g === void 0 ? 10 : _g, _h = _b.liquidityMin, liquidityMin = _h === void 0 ? 1000 : _h, _j = _b.volumeMin, volumeMin = _j === void 0 ? 1000 : _j, _k = _b.mktCapMin, mktCapMin = _k === void 0 ? 5000 : _k, _l = _b.timeFrame, timeFrame = _l === void 0 ? '24' : _l, _m = _b.rankingBy, rankingBy = _m === void 0 ? 'marketCap' : _m, _o = _b.rankingDirection, rankingDirection = _o === void 0 ? 'desc' : _o, _p = _b.addNatives, addNatives = _p === void 0 ? true : _p, _q = _b.sortSearchResultsViaAlgo, sortSearchResultsViaAlgo = _q === void 0 ? true : _q, identifier = _b.identifier, _r = _b.minAgeMinutes, minAgeMinutes = _r === void 0 ? 0 : _r, filterStables = _b.filterStables, _s = _b.minUniqueTransactions, minUniqueTransactions = _s === void 0 ? 25 : _s, _t = _b.maxAgeMinutes, maxAgeMinutes = _t === void 0 ? 999999999999999 : _t, _u = _b.showPotentialScam, showPotentialScam = _u === void 0 ? false : _u;
        return __generator(this, function (_v) {
            switch (_v.label) {
                case 0:
                    if (identifier === 'search' && (!phrase || phrase.length < 2)) {
                        return [2 /*return*/, []];
                    }
                    networks = network.join(',');
                    url = "/api/explore/tokenSearch?limit=".concat(limit, "&phrase=").concat(phrase, "&network=").concat(networks, "&txnCountMin=").concat(txnCountMin, "&liquidityMin=").concat(liquidityMin, "&volumeMin=").concat(volumeMin, "&mktCapMin=").concat(mktCapMin, "&timeFrame=").concat(timeFrame, "&rankingBy=").concat(rankingBy, "&rankingDirection=").concat(rankingDirection, "&minAgeMinutes=").concat(minAgeMinutes, "&minUniqueTransactions=").concat(minUniqueTransactions, "&maxAgeMinutes=").concat(maxAgeMinutes, "&showPotentialScam=").concat(showPotentialScam);
                    result = [];
                    _v.label = 1;
                case 1:
                    _v.trys.push([1, 6, , 7]);
                    if (!(phrase !== '' && (phrase === null || phrase === void 0 ? void 0 : phrase.length) >= 3)) return [3 /*break*/, 3];
                    nativeTokenIds = [];
                    for (index = 0; index < nativeTokens.length; index++) {
                        if (((_c = nativeTokens[index].tokenName.toUpperCase()) === null || _c === void 0 ? void 0 : _c.includes(phrase.toUpperCase())) ||
                            ((_d = nativeTokens[index].token.toUpperCase()) === null || _d === void 0 ? void 0 : _d.includes(phrase.toUpperCase()))) {
                            nativeTokenIds.push(nativeTokens[index]);
                        }
                    }
                    if (!(nativeTokenIds.length > 0 && addNatives)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all((nativeTokenIds || []).map(function (tokenInfo) { return __awaiter(_this, void 0, void 0, function () {
                            var res, nativeToken;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, getBasicTokenInfo(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.network, tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.wrappedAddress)];
                                    case 1:
                                        res = _b.sent();
                                        nativeToken = __assign({ token: __assign(__assign({}, res === null || res === void 0 ? void 0 : res.token), { name: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.tokenName, symbol: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.token, address: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.tokenAddress, imageLargeUrl: getNetworkLogo(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.network), imageSmallUrl: getNetworkLogo(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.network), imageThumbUrl: getNetworkLogo(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.network), info: {
                                                    imageLargeUrl: getNetworkLogo(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.network),
                                                    imageSmallUrl: getNetworkLogo(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.network),
                                                    imageThumbUrl: getNetworkLogo(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.network),
                                                } }) }, (_a = res.tokenInfo) === null || _a === void 0 ? void 0 : _a.results[0]);
                                        result.push(nativeToken);
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _v.sent();
                    _v.label = 3;
                case 3: return [4 /*yield*/, fetch(url)];
                case 4:
                    response = _v.sent();
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return [4 /*yield*/, response.json()];
                case 5:
                    payload = _v.sent();
                    data = payload === null || payload === void 0 ? void 0 : payload.data;
                    result = result.concat((_f = (_e = data.data) === null || _e === void 0 ? void 0 : _e.filterTokens) === null || _f === void 0 ? void 0 : _f.results);
                    if (sortSearchResultsViaAlgo) {
                        result = findBestMatch(phrase, result);
                    }
                    ethTokens = result.filter(function (result) { var _a; return result.token && ((_a = result === null || result === void 0 ? void 0 : result.token) === null || _a === void 0 ? void 0 : _a.networkId) === ChainId.ETHEREUM; });
                    bnbTokens = result.filter(function (result) { var _a; return result.token && ((_a = result === null || result === void 0 ? void 0 : result.token) === null || _a === void 0 ? void 0 : _a.networkId) == ChainId.BSC; });
                    otherTokens = result.filter(function (result) {
                        var _a, _b;
                        return !result.token ||
                            (((_a = result === null || result === void 0 ? void 0 : result.token) === null || _a === void 0 ? void 0 : _a.networkId) !== ChainId.ETHEREUM && ((_b = result === null || result === void 0 ? void 0 : result.token) === null || _b === void 0 ? void 0 : _b.networkId) !== ChainId.BSC);
                    });
                    result = __spreadArray(__spreadArray(__spreadArray([], otherTokens, true), bnbTokens, true), ethTokens, true);
                    if (filterStables) {
                        result = result.filter(function (result) {
                            var usdPrice = parseFloat(result.priceUSD);
                            var low12 = parseFloat(result.low12);
                            var high12 = parseFloat(result.high12);
                            var inThreshold = function (price) { return price > 0.99 && price < 1.01; };
                            if (inThreshold(usdPrice) && inThreshold(low12) && inThreshold(high12)) {
                                return false;
                            }
                            return true;
                        });
                    }
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _v.sent();
                    console.error('searchResults error', error_2);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, result || []];
            }
        });
    });
}
export function useTokenSearch(_a) {
    var _this = this;
    var limit = _a.limit, phrase = _a.phrase, _b = _a.network, network = _b === void 0 ? [1, 137, 10, 56, 43114, 42161, 250, 8453] : _b, _c = _a.txnCountMin, txnCountMin = _c === void 0 ? 1000 : _c, _d = _a.liquidityMin, liquidityMin = _d === void 0 ? 1000 : _d, _e = _a.volumeMin, volumeMin = _e === void 0 ? 10000 : _e, _f = _a.mktCapMin, mktCapMin = _f === void 0 ? 10000 : _f, _g = _a.minUniqueTransactions, minUniqueTransactions = _g === void 0 ? 25 : _g, _h = _a.timeFrame, timeFrame = _h === void 0 ? '24' : _h, _j = _a.rankingBy, rankingBy = _j === void 0 ? 'volume24' : _j, _k = _a.rankingDirection, rankingDirection = _k === void 0 ? 'DESC' : _k, _l = _a.addNatives, addNatives = _l === void 0 ? true : _l, _m = _a.sortSearchResultsViaAlgo, sortSearchResultsViaAlgo = _m === void 0 ? true : _m, _o = _a.minAgeMinutes, minAgeMinutes = _o === void 0 ? -1 : _o, _p = _a.maxAgeMinutes, maxAgeMinutes = _p === void 0 ? 99999999999999 : _p, identifier = _a.identifier, filterStables = _a.filterStables, _q = _a.cacheTime, cacheTime = _q === void 0 ? 1000 * 60 * 5 : _q, _r = _a.showPotentialScam, showPotentialScam = _r === void 0 ? false : _r;
    var _s = useState(phrase), debouncedPhrase = _s[0], setDebouncedPhrase = _s[1];
    var debouncedSetPhrase = useMemo(function () { return debounce(setDebouncedPhrase, 300); }, []);
    useEffect(function () {
        debouncedSetPhrase(phrase);
        return function () {
            debouncedSetPhrase.cancel();
        };
    }, [phrase, debouncedSetPhrase]);
    var params = {
        limit: limit,
        phrase: debouncedPhrase,
        network: network,
        txnCountMin: txnCountMin,
        liquidityMin: liquidityMin,
        volumeMin: volumeMin,
        mktCapMin: mktCapMin,
        timeFrame: timeFrame,
        rankingBy: rankingBy,
        rankingDirection: rankingDirection,
        addNatives: addNatives,
        sortSearchResultsViaAlgo: sortSearchResultsViaAlgo,
        identifier: identifier,
        minAgeMinutes: minAgeMinutes,
        filterStables: filterStables,
        maxAgeMinutes: maxAgeMinutes,
        minUniqueTransactions: minUniqueTransactions,
        showPotentialScam: showPotentialScam,
    };
    var query = useQuery({
        queryKey: __spreadArray(['fetchTokens'], Object.values(params), true),
        staleTime: cacheTime,
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchTokens(__assign({}, params))];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results];
                }
            });
        }); },
        enabled: !!identifier,
    });
    return query;
}
export default useTokenSearch;
